(function() {
  'use strict';

  function initializeDropdowns(container = document) {
    const dropdowns = container.querySelectorAll('.product-variant-dropdown');

    dropdowns.forEach(dropdown => {
      if (dropdown.hasAttribute('data-dropdown-initialized')) return;
      dropdown.setAttribute('data-dropdown-initialized', 'true');

      updateTriggerText(dropdown);

      const options = dropdown.querySelectorAll('li');
      options.forEach(li => {
        li.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          selectOption(li, dropdown);
        });
      });
    });
  }

  document.addEventListener('click', function(e) {
    const dropdown = e.target.closest('.product-variant-dropdown');

    if (dropdown && !e.target.closest('li') && !e.target.closest('ul')) {
      e.preventDefault();
      e.stopPropagation();
      toggleDropdown(dropdown);
    } else if (!dropdown) {
      closeAllDropdowns();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAllDropdowns();
    }
  });

  document.addEventListener('scroll', function() {
    document.querySelectorAll('.product-variant-dropdown.open').forEach(updateDropdownDirection);
  }, true);

  window.addEventListener('resize', function() {
    document.querySelectorAll('.product-variant-dropdown.open').forEach(updateDropdownDirection);
  });

  function toggleDropdown(dropdown) {
    const isOpen = dropdown.classList.contains('open');

    closeAllDropdowns();

    if (!isOpen) {
      updateDropdownDirection(dropdown);
      dropdown.classList.add('open');
    }
  }

  function closeAllDropdowns() {
    document.querySelectorAll('.product-variant-dropdown.open').forEach(dropdown => {
      dropdown.classList.remove('open');
    });
  }

  function updateDropdownDirection(dropdown) {
    dropdown.classList.remove('open-up');

    const quickAddModal = dropdown.closest('quick-add-modal.quick-add-modal');
    if (!quickAddModal) return;

    const dropdownList = dropdown.querySelector('ul');
    if (!dropdownList) return;

    const boundary =
      quickAddModal.querySelector('.modal__inner') ||
      quickAddModal.querySelector('.modal__content') ||
      quickAddModal;
    const boundaryRect = boundary.getBoundingClientRect();
    const dropdownRect = dropdown.getBoundingClientRect();
    const dropdownStyles = window.getComputedStyle(dropdownList);
    const maxHeightFromCss = parseFloat(dropdownStyles.maxHeight) || Number.POSITIVE_INFINITY;
    const maxHeight = Math.min(maxHeightFromCss, 250);
    const marginTop = parseFloat(dropdownStyles.marginTop) || 0;
    const marginBottom = parseFloat(dropdownStyles.marginBottom) || 0;
    const listHeight = Math.min(dropdownList.scrollHeight, maxHeight) + marginTop + marginBottom;
    const spaceBelow = boundaryRect.bottom - dropdownRect.bottom;
    const spaceAbove = dropdownRect.top - boundaryRect.top;
    const shouldOpenUp = spaceBelow < listHeight && spaceAbove > spaceBelow;
    const verticalBuffer = 12;
    const availableSpace = shouldOpenUp ? spaceAbove : spaceBelow;
    const constrainedHeight = Math.max(140, Math.min(maxHeight, Math.floor(availableSpace - verticalBuffer)));

    dropdown.style.setProperty('--quick-add-dropdown-max-height', `${constrainedHeight}px`);

    if (shouldOpenUp) {
      dropdown.classList.add('open-up');
    }
  }

  function selectOption(li, dropdown) {
    const radioInput = li.querySelector('input[type="radio"]');

    if (!radioInput || radioInput.disabled) return;

    radioInput.checked = true;

    dropdown.querySelectorAll('li').forEach(item => {
      item.classList.remove('selected');
    });
    li.classList.add('selected');

    updateTriggerText(dropdown);

    const fieldset = dropdown.closest('fieldset');
    const legendSpan = fieldset?.querySelector('[data-selected-value-option]');
    const selectedText = li.querySelector('label span')?.textContent;

    if (legendSpan && selectedText) {
      legendSpan.textContent = selectedText;
    }

    dropdown.classList.remove('open');

    radioInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function updateTriggerText(dropdown) {
    const checkedInput = dropdown.querySelector('input[type="radio"]:checked');
    const selectedText = checkedInput ?
      checkedInput.closest('li').querySelector('label span').textContent :
      'Select an option';

    dropdown.setAttribute('data-selected-text', selectedText);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeDropdowns());
  } else {
    initializeDropdowns();
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.querySelector && node.querySelector('.product-variant-dropdown')) {
              setTimeout(() => initializeDropdowns(node), 10);
            }
            if (node.classList && node.classList.contains('product-variant-dropdown')) {
              setTimeout(() => initializeDropdowns(node.parentElement), 10);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('modal:open', function() {
    setTimeout(() => initializeDropdowns(), 100);
  });

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
      const modals = document.querySelectorAll('quick-add-modal, [class*="modal"]');
      modals.forEach(modal => {
        if (modal.querySelector('.product-variant-dropdown')) {
          initializeDropdowns(modal);
        }
      });
    }, 500);
  });

  window.reinitDropdowns = function() {
    document.querySelectorAll('[data-dropdown-initialized]').forEach(el => {
      el.removeAttribute('data-dropdown-initialized');
    });
    initializeDropdowns();
  };

})();
